import {Tag} from "primereact/tag";
import React from "react";

export const stringArrayToTags = (arr: string[]) => {
    return <div style={{display: "flex", gap: 2, flexWrap: "wrap"}}>
        {arr.map((ob, key) => {
            return <div key={key}><Tag value={ob} rounded></Tag></div>
        })}
    </div>
}
